import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL_BASE + "api/bot-trades";

export async function getBotTrades(params = {}) {
  const res = await axios.get(API_URL, { params, headers: authHeader() });
  return res.data;
}

export async function getBotTradesFilters() {
  const res = await axios.get(API_URL + "/filters", { headers: authHeader() });
  return res.data;
}

export async function saveBotTradeNote(tradeKey, note) {
  const res = await axios.put(
    API_URL + "/notes/" + encodeURIComponent(tradeKey),
    { note },
    { headers: authHeader() }
  );
  return res.data;
}
